<template>
  <div class="content-view">
    <div class="sc-message-list" ref="scroller">
      <Message v-for="(message,index) in messages" 
        :message="message"
        :messagePrev="prevMessage(index)" 
        :key="'msg' + index"
        :progress="(message.id==progressMessageId)?progress:0"
      />

      <Message v-for="(typingMessage, idx) in typingMessages" 
        :message="typingMessage" 
        :key="idx" 
      />
    </div>

    <v-menu
      v-model="contextMenu.show"
      :position-x="contextMenu.x"
      :position-y="contextMenu.y"
      absolute
      auto
      v-right-click-outside="closeContextMenu"
    >
      <v-list>
        <v-list-tile
          v-for="(item, index) in contextMenu.items"
          :key="'context-menu-' + index"
          @click="menuItemClicked(index)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <div class="arrow-down-wrapper" ref="arrowDown">
      <v-btn
        key="keyboard_arrow_down"
        fab
        class="arrow-down-btn"
        @click="_scrollDown"
      >
        <v-icon>keyboard_arrow_down</v-icon>
      </v-btn>
    </div>
    <audio ref="audio" />
  </div>
</template>

<script>
  import Message from './Message.vue'
  import { EventBus } from '@/event-bus'
  import { i18n } from '@plugins/i18n'
  import baseUtils from '@utils/base'
  import fileSelector from '@utils/fileSelector'

  const REPLY = 0
  const COPY = 1
  const SAVE_AS = 2
  const FORWARD = 3
  const DELETE_MINE = 4
  const DELETE_ALL = 5

  export default {
    name: 'content-view',
    components: { 
      Message
    },
    props: {
      searchable: {
        type: String, 
        default: ""
      }
    },
    data () {
      return {
        messages: [],
        messageOffset: 0, // message query offset without dates
        lastMessageDate: null,
        lock: 0, // TODO: temporary fix from too often chatChanged async calls
        typingMessages: [],
        arrowDownVisible: false,
        // TODO: some strange things here, why progress is one per message?
        progressMessageId: 0,
        progress: 0,
        // Search
        currentSearch: 0,
        playMassageId: 0,
        // menu
        contextMenu: {
          show: false,
          x: 0,
          y: 0,
          message: null,
          items: []
        },
      }
    },
    mounted() {
      EventBus.$on('view-message', this.viewMessage)
      this.$refs.scroller.addEventListener('scroll', this.scrollHandler)
      EventBus.$on('audio-message-clicked', this.audioMessageClicked)
      EventBus.$on('audio-message-play-next', this.audioMessagePlayNext)
      EventBus.$on('show-context-menu', this.showContextMenu)
      this.$nextTick(this._scrollDown())
    },
    beforeDestroy() {
      EventBus.$off('view-message')
      this.$refs.scroller.removeEventListener('scroll', this.scrollHandler)
      EventBus.$off('audio-message-play-next')
      EventBus.$off('audio-message-clicked')
    },
    updated() {
      this.$nextTick(this._scrollDown())
    },
    methods: {
      showContextMenu(arg) {
        let message = arg.message

        this.contextMenu.show = false
        if (message.type == this.types.RemoveMessage)
          return

        let items = [
          { title: this.$t('reply'), id: REPLY },
          { title: this.$t('chat_chat_message_copy'), id: COPY },
          { title: this.$t('file_save_as'), id: SAVE_AS },
          { title: this.$t('chat_chat_message_forward'), id: FORWARD },
          { title: this.$t('message_delete_myself'), id: DELETE_MINE },
          { title: this.$t('message_delete_everyone'), id: DELETE_ALL },
        ]
        this.contextMenu.items = items.filter(it => {
          let hide = 
            (it.id == 1 && message.type != this.types.TextMessage) ||
            (it.id == 2 && !this.types.isFileType(message.type)) ||
            (it.id == 5 && !message.sent)
          return !hide        
        })

        this.contextMenu.x = arg.x
        this.contextMenu.y = arg.y
        this.contextMenu.message = message

        this.$nextTick(() => this.contextMenu.show = true)
      },
      closeContextMenu() {
        console.log('-- closed context menu:', this.contextMenu.show)
        //this.contextMenu.show = false
      },
      menuItemClicked(index) {
        console.log('--- menuItemClicked: ' + index)
        const m = this.contextMenu.message
        switch (this.contextMenu.items[index].id) {
          case REPLY:
            EventBus.$emit('reply-message', m)
            break
          case COPY:
            baseUtils.textToClipboard(m.content)
            break
          case SAVE_AS: {
              const name = m.data.name !== undefined ? m.data.name : m.content
              let filter = undefined
              if (m.type === this.types.VideoMessage) {
                filter = fileSelector.getVideosFilter(this)
              } else if (m.type === this.types.ImageMessage) {
                filter = fileSelector.getImagesFilter(this)
              }
              const path = m.content
              this.$store.dispatch('saveFileAs', { path, name, filter })
            }
            break
          case FORWARD:
            EventBus.$emit('forward-chat-message', m.id)
            break
          case DELETE_MINE:
            this.$store.dispatch('removeChatMessage', { messageId:m.id, remotely:false })
            break
          case DELETE_ALL:
            this.$store.dispatch('removeChatMessage', { messageId:m.id, remotely:true })
            break
        }
      },
      audioMessageClicked(args) {
        const player = this.$refs.audio
        if (!args.play) {
          player.pause()
          player.src = ''
          this.playMassageId = 0
        } else {
          EventBus.$emit('audio-message-stop', this.playMassageId)
          this.audioPlaying = true
          player.src = args.path
          player.play()
          this.playMassageId = args.messageId
          EventBus.$emit('audio-message-plaing', args.messageId)
        } 
      },
      audioMessagePlayNext() {
        let messageFound = false
        for(let i=0;i<this.messages.length; i++) {
          if (messageFound) {
            if (this.messages[i].type == this.types.AudioMessage) {
              EventBus.$emit('audio-message-play', this.messages[i].id)
              return
            }
          } else {
            if (this.playMassageId == this.messages[i].id)
              messageFound = true
          }
        }
      },
      chatChanged() {
        console.log('-- chatChanged: lock = ', this.lock)
        if (this.lock > 0)
          return
      },
      chatMessageUpdated(messageId) {
        const pos = this.messages.findIndex(item => item.id === messageId)
        if (pos < 0)
          return
        const chatId = this.$store.state.currentChat.chatId
        this.$store.dispatch('fetchChatMessage', { chatId: chatId, messageId: messageId }).then((msg) => {
          let m = this.convertMessage(msg)
          this.updateMessage(m)
        })
      },
      updateTtlMessageProgress(args) {
        //console.log('-- messageList updateTtlMessageProgress: ' + JSON.stringify(args))
        this.progressMessageId = args.messageId
        this.progress = args.progress
        //console.log('-- messageList progressMessageId:', this.progressMessageId, "progress:", this.progress)
      },
      chatTypingUpdated(contactName, avatar, show) {
        const index = this.typingMessages.findIndex(m => m.author == contactName)
        if (show && index == -1)
          this.typingMessages.push({author:contactName, avatar:avatar,type: this.types.TypingMessage})
        else if (index > -1) 
          this.typingMessages.splice(index, 1)

        console.log('-- (ui) typingMessages count:', this.typingMessages.length, index)
      },
      /**
       * Load chat messages
       */
      reload() {
        this.lock++
        this.messages = []
        this.typingMessages = []
        this.lastMessageDate = null
        this.arrowDownVisible = false

        this.$store.dispatch('fetchChatMessages', { 
          chatId: this.$store.state.currentChat.chatId, 
          offset: 0 
        }).then((items) => {
          //console.log('-- reload(): ' + JSON.stringify(items), ' ', items.length)
          this.messageOffset = items.length
          this.messages = this.convertMessages(items.reverse())
          this.lock--
        })
      },
      fetchNextPage() {
        return new Promise((resolve) => {
          this.$store.dispatch('fetchChatMessages', { 
            chatId: this.$store.state.currentChat.chatId, 
            offset: this.messageOffset
          }).then((items) => {
            if (items.length < 1)
              return
            this.messageOffset += items.length

            let msgs = this.convertMessages(items.reverse())
            for (let i = 0, n = msgs.length; i < n; i++) {
              this.messages.splice(i, 0, msgs[i])
            }
            resolve()
          })
        })
      },
      loadNextPage() {
        console.log('-- pull to load: ', this.messages.length, ' ', this.messageOffset)

        const currentHeight = this.$refs.scroller.scrollHeight
        this.fetchNextPage().then(() => {
          //this.$nextTick(() => s.scrollTop = s.scrollHeight - currentHeight)
          const s = this.$refs.scroller
          s.scrollTop = s.scrollHeight - currentHeight
        })
      },
      messageReceived(messageId, chatId) {
        if (!chatId)
          chatId = this.$store.state.currentChat.chatId

        // prevent duplicate (when chat title changed) (TODO: temporary hack)
        let m = null
        for (let i = this.messages.length - 1; i >= 0; i--) {
          if (this.messages[i].id == messageId) {
            m = this.messages[i]
            break
          }
        }

        this.$store.dispatch('fetchChatMessage', {chatId, messageId}).then(msg => {
          if (!m)
            this.messages.push(this.convertMessage(msg))
          if (document.hasFocus()) {
            this.$store.dispatch('markReadChatMessage', messageId)
          }
        })
      },
      convertMessages(items) {
          let lastDay = null
          let messagesWithDates = []
          const dateOptions = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'}
        
          for (let i = 0, n = items.length; i < n; i++) {
            const message = this.convertMessage(items[i])
            if (message.date) {
              const date = new Date(message.date)
              if (!lastDay || lastDay != date.getDate()) {
                lastDay = date.getDate()
                messagesWithDates.push({
                  message: date.toLocaleDateString(i18n.locale, dateOptions), 
                  type: this.types.DateMessage
                })
                messagesWithDates.push(message)
              } else {
                messagesWithDates.push(message)
              }
            } else {
              throw new Error('Message without date' + JSON.stringify(message))
            }
          }

          this.lastMessageDate = lastDay
          return messagesWithDates
      },
      /**
       * Convert core message format to UI message
       */
      convertMessage(item) {
        const dateTime = item.when.split(' ')
        let m = {
          id: item.messageId,
          author: item.user,
          authorName: item.sent ? this.$t('image_preview_your_image') : item.userName,
          avatar: '',
          sent: item.sent,
          state: item.state,
          type: item.type,
          time: dateTime[1],
          date: dateTime[0],

          content: item.message,
          data: {}
        }

        switch (item.type) {
          case this.types.TextMessage:
            if(item.extra && item.extra.linkMetadata) {
              m.data = {
                linkMetadata:  JSON.parse(item.extra.linkMetadata),
                linkImage: item.extra.linkImage,
              }
            }
            break
          case this.types.ImageMessage:            
            m.data = {
              preview: item.thumb,
              ttl: item.ttl
            }
            break
          case this.types.VideoMessage: 
            m.data = {
              preview: item.thumb,
              ttl: item.ttl
            }
            break
          case this.types.LocationMessage: {
              let location = item.message.split("_")
              m.data = {
                lat: Number(location[0]),
                lng: Number(location[1])
              }
            }
            break
          case this.types.ContactMessage: 
            m.data = {
              id: item.message,
              name: item.extra.originalName
            }
            break
          case this.types.DocumentMessage: 
            m.data = {
              name: item.extra.originalName,
              size: item.extra.fileSize
            }
            break
          case this.types.AudioMessage:
            console.log('-- fetch AudioMessage: ',item.extra)
            m.data = {
              duration: item.extra.duration
            }
            break
          case this.types.TimerMessage: 
            m.data = {
              ttl: item.ttl
            }
            break
          case this.types.ChatDetailsMessage: {
              let title = ""
              if (item.extra.notificationType == 0)
                title = item.extra.chatTitle
              m.data = {
                notificationType: item.extra.notificationType,
                chatTitle: title
              }
            }
            break
          case this.types.RemoveMessage: 
            m.content = (!item.sent) 
              ? this.$t("message_deleted_notification", [m.authorName])
              : this.$t("message_you_deleted_notification")
            break
        }
//TODO: move to message? delayed loading should be
        if (item.extra && item.extra.replyId) {
          //console.log('-- reply: ' + JSON.stringify(item))
          m.data.reply = this.fetchConvertedMessage(Number(item.extra.replyId))
        }
        return m
      },
      /**
       * Fetch a message without using async dispatch
       */
      fetchConvertedMessage(messageId) {
        let chatId = this.$store.state.currentChat.chatId      
        let msg = EventBus.getChatMessage(chatId, messageId)
        if (Object.keys(msg).length > 0) {
          const contact = this.$store.state.contacts.find(c => c.contactId === msg.user)
          msg.userName   = (contact !== undefined) ? contact.name : msg.user
          msg.userAvatar = (contact !== undefined) ? contact.avatar : ''
          return this.convertMessage(msg)
        }
        return msg
      },
      openActiveCall() {
        EventBus.$emit('open-call-window')
      },
      /**
       * Scroll event handler
       */
      scrollHandler(ev) {
        if (ev.target.scrollTop == 0)
          this.loadNextPage()

        const s = ev.target       
        const visible = ((s.scrollTop + s.clientHeight * 1.5) < s.scrollHeight && s.scrollHeight > s.clientHeight) 
        if (visible != this.arrowDownVisible) {
          this.arrowDownVisible = visible
          this.$refs.arrowDown.style.visibility = (visible) ? 'visible' : 'hidden'
          // fix with scrolling interrupts
          this.$nextTick(() => this.$refs.scroller.focus())
        }
      },
      _scrollDown() {
        const s = this.$refs.scroller
        s.scrollTop = s.scrollHeight
      },
      updateMessage(msg) {
        const pos = this.messages.findIndex(item => item.id === msg.id)
        if (pos !== -1)
          this.$set(this.messages, pos, msg)
      },
      prevMessage(index) {
        return (index - 1) >= 0 ? this.messages[index - 1] : null
      },
      focusChanged() {
        let count = EventBus.getChatUnreadCount(this.$store.state.currentChat.chatId)
        if (count < 1)
          return
        const items = this.messages
        for (let i = 0, n = items.length; i < n; i++) {
          const m = items[n - i - 1]
          if (!m.sent && m.state == 3)
            break
          //console.log('' + JSON.stringify(m))
          if (m.id !== undefined)
            this.$store.dispatch('markReadChatMessage', m.id)
        }
      },
      searchUp() {
        let s = this.currentSearch != 0 
          ? this.messages.findIndex(it => it.id == this.currentSearch)
          : this.messages.length

        let nextMessage = 0
        for (let i = s - 1; i >= 0; i--) {
          let item = this.messages[i]
          if (item.type == this.types.TextMessage && item.content.indexOf(this.searchable) >= 0) {
            nextMessage = item.id
            break
          }
        }

        console.log('--- nextMessage:', nextMessage)

        if (nextMessage != 0) {
          this.$nextTick(this.markSearchable(nextMessage))
          return
        }

        this.$store.dispatch('searchNext', {
          chatId: this.$store.state.currentChat.chatId,
          offset: this.messageOffset, 
          searchable: this.searchable
        }).then((result) => {
          if (!result) {
            // TODO:
            return
          }

          const items = result.items
          const item  = result.message
          if (items.length < 1)
            return

          this.messageOffset += items.length

          const s = this.$refs.scroller
          const currentHeight = s.scrollHeight

          let msgs = this.convertMessages(items.reverse())
          for (let i = 0, n = msgs.length; i < n; i++) {
            this.messages.splice(i, 0, msgs[i])
          }

          this.$nextTick(() => {
            s.scrollTop = s.scrollHeight - currentHeight
            this.markSearchable(item.messageId)
          })
        })
      },
      searchDown() {
        let s = this.currentSearch != 0 
          ? this.messages.findIndex(it => it.id == this.currentSearch)
          : 0

        let nextMessage = 0
        for (let i = s + 1; i < this.messages.length; i++) {
          let item = this.messages[i]
          if (item.type == this.types.TextMessage && item.content.indexOf(this.searchable) >= 0) {
            nextMessage = item.id
            console.log('---- currentSearch', nextMessage, item.content)
            break
          }
        }

        if (nextMessage != 0)
          this.$nextTick(this.markSearchable(nextMessage))       
      },
      resetCurrentSearch() {
        if (this.currentSearch != 0) {
          console.log('--- resetCurrentSearch', this.currentSearch)

          const mid = this.currentSearch
          let cur = document.getElementById(mid)
          if (cur) {
            // TODO kill child
            cur.innerHTML = cur.innerHTML.replace('<mark>', '').replace('</mark>','')
            ///console.log('-- html', cur.innerHTML)
          }
          this.currentSearch = 0
        }
      },
      markSearchable(nextMessage) {
        let markedText = '<mark>' + this.searchable + '</mark>'

        // reset previous selection
        this.resetCurrentSearch()
        this.currentSearch = nextMessage

        let msg = document.getElementById(nextMessage)
        if (msg) {
          // TODO: go with childs
          msg.innerHTML = msg.innerHTML.replace(this.searchable, markedText)
          msg.scrollIntoView({block: "nearest", inline: "nearest", behavior: "instant"})
        }    
      },
      viewMessage(messageId) {
        let msg = document.getElementById(messageId)
        if (msg) {
          msg.scrollIntoView({block: "nearest", inline: "nearest", behavior: "instant"})
        } else {
          this.fetchNextPage().then(() => this.viewMessage(messageId))
        }
      }
    },
    watch: {
      searchable: function(newValue, oldValue) {
        this.resetCurrentSearch()
        if (newValue != oldValue && newValue == '')
          return

        console.log('--- searchable', newValue, this.currentSearch)
        this.searchUp()
      }
    }
  }
</script>

<style>
  .content-view {
    padding:0;
    border: 0px dotted red;
    display: flex;
  }
  .content-view .sc-message-list {
    /*height: 100%;*/
    width:100%;
    overflow-x: hidden;
    overflow-y: overlay;
    background-size: 100%;
    padding: 16px 9px;
  }
  .content-view .sc-message-list:not(.focus):not(:hover)::-webkit-scrollbar {
    display: none;
  }

  .arrow-down-wrapper {
    /* border: 0px dotted blue; */
    align-self: flex-end;
    position: absolute; 
    right: 0;
    visibility:hidden; /* invisible by default */
  }
  .arrow-down-wrapper .arrow-down-btn { 
    width: 48px !important; 
    height: 48px !important;
    background-color:  var(--v-baseBackground-base) !important;
  }
</style>